import React from 'react';
import PropTypes from 'prop-types';
import { IconChevronUp, IconChevronDown } from '@piggybank/core';
import styles from './styles.css';

const ToggleMenuButton = ({
  disabled,
  getToggleButtonProps,
  isOpen,
  toggleMenuAriaLabel,
}) => {
  const Icon = isOpen ? IconChevronUp : IconChevronDown;
  return (
    <button
      disabled={disabled}
      className={styles.dropdownButton}
      type="button"
      {...getToggleButtonProps()}
      aria-label={toggleMenuAriaLabel}
    >
      <Icon marginBottom={0} />
    </button>
  );
};

ToggleMenuButton.propTypes = {
  disabled: PropTypes.bool,
  getToggleButtonProps: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleMenuAriaLabel: PropTypes.string.isRequired,
};

export default ToggleMenuButton;
